//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

export const MARKETO_SDK_URL =
  'https://resources.bazaarvoice.com/js/forms2/js/forms2.min.js';
export const MARKETO_SCRIPT_ID = 'vibe-marketo';
export const MARKETO_BASE_URL = 'https://resources.bazaarvoice.com';
export const MARKETO_MUNCHKIN_ID = '848-PGD-174';
export const MARKETO_FORM_ID = 'mktoForm_5025';
export const MARKETO_FORM_VERSION_ID = 5025;

export const Prefix: TrackingIdPrefix = 'marketo-integration-';

export const MarketoIntegrationTrackingIds = {
  BAZAARVOICE_SUPPORT_LINK: `${Prefix}bazaarvoice-support-link`,
  MODAL_CANCEL_BUTTON: `${Prefix}modal-cancel-button`,
  MODAL_FORM_SUBMIT_BUTTON: `${Prefix}modal-form-submit-button`,
  MODAL: `${Prefix}modal`,
  OPEN_MODAL_BUTTON: `${Prefix}open-modal-button`,
} as const satisfies Record<string, TrackingId>;
